export function foo() { console.log('foo') }
export function bar() { console.log('bar') }
export function scrollingTo(e, elementId) { 
    e.preventDefault()
    const element = document.getElementById(elementId)
    element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
}


export default {foo, bar, scrollingTo}